import { Component, h, Host } from '@stencil/core';
import { get } from './welcome-modal-store';

@Component({
  tag: 'welcome-modal',
  styleUrl: 'welcome-modal.scss',
})
export class WelcomeModal {
  get isModalShown(): boolean {
    return get('isModalShown');
  }

  render() {
    return <Host class={{'active': this.isModalShown}}>
      <div class="background"/>
      <welcome-info-modal/>
      <welcome-success-modal/>
    </Host>
  }
}
